import React from "react";

const Footer = () => {
  return (
    <footer className="bg-dark text-center py-3 text-white ">
      <div className="container d-flex justify-content-between align-items-center">
        <p className="m-0 small">© 2021 All CopyRight Reserved</p>
        <p className="m-0 small">La-School, Inc</p>
      </div>
    </footer>
  );
};

export default Footer;
